"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrictMap = void 0;
const IterableMap_1 = require("./IterableMap");
const StrictTypeGuard_1 = require("./StrictTypeGuard");
class StrictMap extends IterableMap_1.IterableMap {
    constructor(enforcedKeyType, entries) {
        super();
        this.guard = new StrictTypeGuard_1.StrictTypeGuard(enforcedKeyType);
        if (entries) {
            for (const [key, value] of entries) {
                this.set(key, value);
            }
        }
    }
    get enforcedKeyType() {
        return this.guard.type;
    }
    set(key, value) {
        this.guard.assertType(key);
        return super.set(key, value);
    }
    get(key) {
        this.guard.assertType(key);
        return super.get(key);
    }
    has(key) {
        this.guard.assertType(key);
        return super.has(key);
    }
    delete(key) {
        this.guard.assertType(key);
        return super.delete(key);
    }
    assertGet(key) {
        this.guard.assertType(key);
        return super.assertGet(key);
    }
}
exports.StrictMap = StrictMap;
//# sourceMappingURL=StrictMap.js.map